import { EditIcon } from 'lucide-react'
import { useState } from 'react'

import { Sheet, SheetContent, SheetTrigger } from '@/_components/ui'

import { EditUserSheet } from './edit-user-sheet'

type EditUserButtonProps = {
  id: string
  name: string
  email: string
  companyId: string
}

export const EditUserButton = ({ id, name, email, companyId }: EditUserButtonProps) => {
  const [IsSheetOpen, setIsSheetOpen] = useState(false)
  return (
    <Sheet open={IsSheetOpen} onOpenChange={setIsSheetOpen}>
      <SheetTrigger asChild>
        <EditIcon size={18} className="cursor-pointer" />
      </SheetTrigger>

      <SheetContent className="scrollbar overflow-y-auto px-0">
        <EditUserSheet
          id={id}
          name={name}
          email={email}
          companyId={companyId}
          setIsSheetOpen={setIsSheetOpen}
        />
      </SheetContent>
    </Sheet>
  )
}
